module.exports = __webpack_public_path__ + "static/img/header-backgroud.76353c36.png";